import { useNavigate } from 'react-router-dom';
import { Card } from '../_misc/layouts/Card';
import { SimpleFooter } from '../_misc/layouts/SimpleFooter';
import classNames from 'classnames';
import { ThemeText } from '../../context/theme/ThemeConstantsUpdated';

const { mainText } = ThemeText;

export const LoginCard = () => {
  const navigate = useNavigate();

  return (
    <Card
      className="mx-auto my-6 max-w-xl"
      header="Thanks but..."
      footer={<SimpleFooter onSubmit={() => navigate('/login')} submitLabel="Login" />}
    >
      <h3 className={classNames(mainText, 'px-0.5 py-5 text-xl')}>Please login before giving me money!</h3>
    </Card>
  );
};
